// Libs
import _ from 'lodash'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'

import { Col, Row } from '../../components/Elemental'

// CSS
import './styles.scss'

// Components/Containers
import Breadcrumb from '../../components/Breadcrumb'
import FilterPanel from '../../containers/FilterPanel'
import DashboardBar from './components/DashboardBar'
import DashboardBox from './components/DashboardBox'
import DashboardJourney from './components/DashboardJourney'
import DashboardLine from './components/DashboardLine'
import DashboardPercentage from './components/DashboardPercentage'
import DashboardTable from './components/DashboardTable'

// Actions
import { changeFilterPanelVisible, fetchFilterPanelReport } from '../FilterPanel/actions'
import { changeDashboardData, exportReport } from './actions'

// Contants

class Dashboard extends Component {
  addFiltersToLink = () => {
    const { period, companies, lawFirms, regions, classifiers } = this.props
    let filters = { period, companies, lawFirms, regions, classifiers }
    let url = '?origin=2&'

    // databoard using archiving as X axios
    delete filters.period

    filters = _.map(filters, (value, key) => ({ key, value }));
    filters.map(filter => {
      const { key, value } = filter

      if (_.isEmpty(value.selected)) return filter

      url += `${key}=`

      value.selected.map(item => {
        url += `${item.value};`
      })

      url += '&'
    })

    return url
  }

  addPeriodToLink = () => {
    const { period } = this.props

    if (_.isEmpty(period.selected)) return ''

    return `&archiving=${period.selected[0].value}`
  }

  render() {
    const { user: { admin, manager, lawFirmId }, data, exporting, visible, loading, period, companies, lawFirms, regions, exportReport,
      changeFilterPanelVisible, fetchFilterPanelReport, differenceMedian, percentageMedian, classifiers } = this.props
    const { addFiltersToLink, addPeriodToLink } = this

    let options = [
      { 'to': '', 'text': 'Alterar Painel de Opções', active: visible, onClick: () => changeFilterPanelVisible(true) },
    ]

    // if ((manager || admin) && !lawFirmId) {
    //   options = [...options, { 'to': '', 'text': exporting ? 'Exportando...' : 'Exportar Relatório', active: exporting, onClick: () => !exporting && exportReport(period, companies, lawFirms, regions, classifiers) }]
    // }

    return (
      <div className="dashboard">
        <div className="dashboard__header">
          <Breadcrumb marginBottom={0} routes={['Dashboard']} />
          <div className="dashboard__header__links">
            {options.map((e, i) =>
              <div
                key={i}
                className={e.active ? 'dashboard__header__links__link dashboard__header__links__link--active' : 'dashboard__header__links__link'}
                onClick={e.onClick}>
                {e.text}
              </div>)}
          </div>
          {/* <Links options={options} /> */}
        </div>
        <Row gutter={3}>
          <Col xs="1/2" md="1/3" lg="1/6" gutter={3}>
            <NavLink to={`/meus-casos/${addFiltersToLink()}status=1`}><DashboardBox title="Casos Em Análise">{data['first']['dynamic']['analysis']}</DashboardBox></NavLink>
          </Col>
          <Col xs="1/2" md="1/3" lg="1/6" gutter={3}>
            <NavLink to={`/meus-casos/${addFiltersToLink()}status=2`}><DashboardBox title="Casos Em Negociação">{data['first']['dynamic']['negotiation']}</DashboardBox></NavLink>
          </Col>
          <Col xs="1/2" md="1/3" lg="1/6" gutter={3}>
            <NavLink to={`/meus-casos/${addFiltersToLink()}status=3`}><DashboardBox title="Casos Em Finalização">{data['first']['dynamic']['finalization']}</DashboardBox></NavLink>
          </Col>
          <Col xs="1/2" md="1/3" lg="1/6" gutter={3}>
            <NavLink to={`/meus-casos/${addFiltersToLink()}status=999&subStatus=1${addPeriodToLink()}`}><DashboardBox title="Casos Com Sucesso">{data['first']['static']['successful']}</DashboardBox></NavLink>
          </Col>
          <Col xs="1/2" md="1/3" lg="1/6" gutter={3}>
            <NavLink to={`/meus-casos/${addFiltersToLink()}status=999&subStatus=2${addPeriodToLink()}`}><DashboardBox title="Casos Sem Sucesso">{data['first']['static']['not_successful']}</DashboardBox></NavLink>
          </Col>
          <Col xs="1/2" md="1/3" lg="1/6" gutter={3}>
            <NavLink to={`/meus-casos/${addFiltersToLink()}status=999&subStatus=3${addPeriodToLink()}`}><DashboardBox title="Casos Não Negociados">{data['first']['static']['not_negotiated']}</DashboardBox></NavLink>
          </Col>
        </Row>
        <Row>
          <Col>
            <DashboardPercentage data={{ successful: data['first']['static']['successful'], unsuccessful: data['first']['static']['not_successful'], notNegotiated: data['first']['static']['not_negotiated'] }} />
          </Col>
        </Row>
        <Row>
          <Col>
            <DashboardLine
              data={data['first']['chart']}
              period={period}
              relativeMedians={{ performance: data['first']['static']['performance'] }} />
          </Col>
        </Row>
        <Row gutter={10}>
          <Col md="1/2" lg="1/5" gutter={10}>
            <DashboardBox style="white" type="percentage" title="Performance Média">{data['first']['static']['performance']}</DashboardBox>
          </Col>
          <Col md="1/2" lg="1/5" gutter={10}>
            <DashboardBox style="white" title="Inserções">{data['first']['static']['entries']}</DashboardBox>
          </Col>
          <Col md="1/2" lg="1/5" gutter={10}>
            <DashboardBox style="white" type="time" title="Tempo Médio de Resposta">{data['first']['static']['average_answer_time']['all']}</DashboardBox>
          </Col>
          <Col md="1/2" lg="1/5" gutter={10}>
            <DashboardBox style="white" type="currency" title="Ticket Médio">{data['first']['static']['average_ticket']}</DashboardBox>
          </Col>
          <Col md="1" lg="1/5" gutter={10}>
            <DashboardBox style="white" type="currency" title="Economia">{data['first']['static']['total_save_provision']}</DashboardBox>
          </Col>
        </Row>
        {!lawFirmId &&
          <Row>
            <Col>
              <DashboardTable
                title="ESCRITÓRIOS"
                variables={[
                  {
                    label: 'MÉTRICAS',
                    value: 'metrics',
                    orderBy: 'successful',
                    data: [
                      { label: 'Nome do Escritório', value: 'name', type: '', order: 'asc' },
                      { label: 'Com Sucesso', value: 'successful', type: '', order: 'desc' },
                      { label: 'Performance', value: 'performance', type: 'percentage', order: 'desc' },
                      { label: 'TMR', value: 'average_answer_time', type: 'time', order: 'asc' },
                      { label: 'Ticket Médio', value: 'average_ticket', type: 'currency', order: 'desc' },
                      { label: 'Economia', value: 'total_save_provision', type: 'currency', order: 'desc' }
                    ]
                  },
                  {
                    label: 'PENDÊNCIAS',
                    value: 'pendencies',
                    orderBy: 'total',
                    data: [
                      { label: 'Nome do Escritório', value: 'name', type: '', order: 'asc' },
                      { label: 'Total', value: 'total', type: 'total', order: 'desc' },
                      { label: 'Primeira Proposta', value: 'first_proposal', type: '', order: 'desc' },
                      { label: 'Contraproposta', value: 'counter_proposal', type: '', order: 'desc' },
                      { label: 'Minuta', value: 'minute', type: '', order: 'desc' },
                      { label: 'Protocolo', value: 'protocol', type: '', order: 'desc' }
                    ]
                  }
                ]}
                data={data['second']} />
            </Col>
          </Row>
        }
        {data['first']['static']['successful'] > 0 &&
          <Row>
            <Col>
              <DashboardJourney data={data['third']} />
            </Col>
          </Row>
        }
        <Row>
          <Col>
            <DashboardBar data={data['fourth']} />
          </Col>
        </Row>
        <FilterPanel />
        <Row>
          <Col>
            {data['fifth'].length > 0 &&
              <DashboardTable
                title="PROPOSTA FORA DO PRETENDIDO"
                metric={{ differenceMedian, percentageMedian }}
                variables={[
                  {
                    label: 'MÉTRICAS',
                    value: 'metrics',
                    orderBy: 'difference_percentage',
                    data: [
                      { label: 'Número do Caso', value: 'case', type: '', order: 'asc' },
                      { label: 'Valor Esperado', value: 'expected_value', type: 'currency', order: 'asc' },
                      { label: 'Alçada', value: 'max_value', type: 'currency', order: 'asc' },
                      { label: 'Diferença', value: 'difference_absolute', type: 'currency', order: 'asc' },
                      { label: '% Diferença', value: 'difference_percentage', type: 'percentage', order: 'asc' },
                      { label: 'Diagnóstico', value: 'tag', type: '', order: 'asc' }
                    ]
                  }
                ]}
                data={data['fifth']}
                to="https://comacordo.com.br/meus-casos/"
              />
            }
          </Col>
        </Row>
      </div>
    )
  }
}

Dashboard = connect(state => {
  return {
    user: state.auth.user,
    data: state.dashboard.data,
    exporting: state.dashboard.exporting,
    visible: state.filterPanel.visible,
    loading: state.filterPanel.loading,
    period: state.filterPanel.period,
    regions: state.filterPanel.regions,
    companies: state.filterPanel.companies,
    lawFirms: state.filterPanel.lawFirms,
    classifiers: state.filterPanel.classifiers,
    differenceMedian: state.dashboard.differenceMedian,
    percentageMedian: state.dashboard.percentageMedian,
    classifiers: state.filterPanel.classifiers
  }
}, { changeDashboardData, exportReport, changeFilterPanelVisible, fetchFilterPanelReport })(Dashboard)

export default Dashboard
